<template>
  <div class="ezy-text" component="ezyText">
    <div
      @mousedown="startPress"
      @mouseup="cancelPress"
      @mouseleave="cancelPress"
      @touchstart="startPress"
      @touchend="cancelPress"
      @touchcancel="cancelPress"
      :style="textStyle"
      class="text-block"
    >
      {{ data.text }}
    </div>
  </div>
</template>

<style>
.ezy-text {
  width: 100%;
  min-height: 25px;
}
.text-block {
  margin: 0 0 22px;
  width: 100%;
  white-space: pre-line;
  word-break: break-word;
  unicode-bidi: plaintext;
  font-family: inherit;
}
::v-deep .text-block {
  user-select: auto !important;
  -moz-user-select: auto !important;
  -webkit-user-select: auto !important;
}
</style>

<script>
const Swal = require("sweetalert2");
/* eslint-disable */
export default {
  name: "textBlock",
  data: () => ({
    data: [],
  }),
  props: {
    textData: Object,
  },
  watch: {
    textData: {
      handler(newTextData) {
        this.initializeMenuData(newTextData);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.textData) {
      this.initializeMenuData(this.textData);
    }
  this.$emit('loaded');
  },
  methods: {
    initializeMenuData(text) {
      if (Array.isArray(text) && text.length > 0) {
        this.data = text[0];
      } else {
        this.data = {};
      }
    },
    startPress() {
      this.pressTimer = setTimeout(() => {
        this.onLongPress();
      }, 1000);
    },
    cancelPress() {
      clearTimeout(this.pressTimer);
      this.pressTimer = null;
    },
    onLongPress() {
      this.$copyText(this.data.text).then(
        function (e) {
          Swal.fire({
            position: "top-center",
            title: "کپی شد",
            showConfirmButton: false,
            fontSize: "20",
            width: "130",
            heightAuto: false,
            background: "rgb(208, 255, 208)",
            timer: 500,
          });
        },
        function (e) {}
      );
    },
  },
  computed: {
    textStyle() {
      if (
        this.data &&
        this.data.textSize &&
        this.data.textAlign &&
        this.data.textColor
      ) {
        return `
           ${this.data.textSize}
          ${this.data.textAlign}
          color:${this.data.textColor};
        `;
      }
      return {};
    },
  },
};
</script>
